import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasemodelService } from 'src/app/basemodel.service';
import { environment } from 'src/environments/environment';




@Injectable({
  providedIn: 'root'
})
export class WifiserviceService {

  constructor(public http: HttpClient,private base:BasemodelService) { }

  public token = ""
  public merakitoken=""

  //======== wifi Form==========//

  getstate() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.base.getWifiURL() + "/jwtV2/api/common/employeeStates", { headers })
  }
  getcity(stateId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.base.getWifiURL() + "/jwtV2/api/common/emplStateCities?stateId=" + stateId, { headers })
  }
  getcampus(cityId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.base.getWifiURL() + "/jwtV2/api/common/empCityCampuses?cityId=" + cityId, { headers })
  }
  getbuliding(campusId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.base.getWifiURL() + "/jwtV2/api/common/empCmpBuilding?campusId=" + campusId, { headers })
  }
  gettable(buildingId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(this.base.getWifiURL() + "/jwtV2/api/common/empBuildingStd?buildingId=" + buildingId, { headers })
  }

  getwifiname(buildingId:any){
    const headers =new HttpHeaders({
      'Authorization':`${this.token}`
    });
    return this.http.get(this.base.getmerakiUrl() + "/api/v1/getNetworkSsids?buildingId=" + buildingId, {headers});
  }

  wifisave(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(this.base.getmerakiUrl() + "/api/v1/saveStdDetails", payload,{ headers })
  }


}
